import axios from 'axios'
import { getToken } from '@BUP/services/auth.js'
import i18n from 'i18next'
const BRAVEUP_API_HOST = import.meta.env.VITE_SCHOOLS_API_HOST
const SOCIOGRAM_API_URL = import.meta.env.VITE_SOCIOGRAM_URL
const BRAVEUP_API_HOST_V2 = import.meta.env.VITE_SCHOOLS_API_HOST_V2
const BRAVEUP_HOST = import.meta.env.VITE_SCHOOLS_API_HOST_ROOT

function getBaseURL (name, version) {
  switch (name) {
    case 'schools':
      switch (version) {
        case 1:
          return BRAVEUP_API_HOST
        case 2:
          return BRAVEUP_API_HOST_V2
        case 3:
          return `${BRAVEUP_HOST}/api/v3`
        case 4:
          return `${BRAVEUP_HOST}/api/v4`
      }
      break
    case 'sociogram':
      return SOCIOGRAM_API_URL
    case 'root':
      return BRAVEUP_HOST
  }
}

export function getApi (name, options = { version: 2, authenticated: true }) {
  options = { version: 2, authenticated: true, ...options }
  const baseURL = getBaseURL(name, options.version)
  const instance = axios.create({ baseURL })

  if (!options.authenticated) return instance

  return getToken().then(token => {
    instance.defaults.headers.common.authorization = `Bearer ${token}`
    // Responses interceptor
    instance.interceptors.response.use(
      (response) => response,
      (error) => {
        if (error.response) {
          // Managing common error codes
          switch (error.response.status) {
            case 401:
              error.code = 'api/no-authorized'
              break
            case 403:
              error.code = 'api/forbidden'
              break
            case 404:
              error.code = 'api/not-found'
              break
            case 405:
              error.code = 'api/not-allowed'
              break
            case 500:
              error.code = 'api/server-error'
              break
            default:
              error.code = 'api/unknown-error'
          }
        } else if (error.request) {
          console.error('error.request: ', error)
          error.code = 'api/server-response'
        } else {
          error.code = 'api/request-config'
        }
        return Promise.reject(error)
      }
    )

    return instance
  })
}

export async function postFetcher (url, { arg }) {
  const client = await getApi('schools', { authenticated: true, version: 4 })
  return client
    .post(url, arg)
    .then(response => response.data)
}

export async function patchFetcher (url, { arg }) {
  const client = await getApi('schools', { authenticated: true, version: 4 })
  return client
    .patch(url, arg)
    .then(response => response.data)
}

export async function getFetcher (url) {
  const client = await getApi('schools', { authenticated: true, version: 4 })
  return client
    .get(url)
    .then(response => response.data)
}

export async function postFileFetcher (url, { arg }) {
  const client = await getApi('schools', { authenticated: true, version: 4 })
  client.defaults.headers.common['Content-Type'] = 'multipart/form-data'
  return client
    .post(url, arg)
    .then(response => response.data)
}
